module.exports = __webpack_public_path__ + "static/media/icon_92.1b36755a.svg";